import React from 'react';
import { SearchBar } from '@brighterion/br-ui';
import SearchButton from './SearchButton';
import styles from './ListEntryTable.css';

type Props = {
    onSubmit(thisValue: string): void;
    placeholderText: string;
    isLoading: boolean;
};

const Search = ({ onSubmit, placeholderText, isLoading }: Props) => {
    const [value, setValue] = React.useState('');

    return (
        <div className={styles.searchContainer} data-testid='list-search-input'>
            <SearchBar
                containerClassName={styles.searchInput}
                size='sm'
                name='table-searchbar'
                value={value}
                onChange={(e) => setValue(e.target.value)}
                placeholder={placeholderText}
                showCloseIcon
                allowPan
            />
            <SearchButton
                onSubmit={() => onSubmit(value)}
                isLoading={isLoading}
                isDisabled={value === '' || isLoading}
            />
        </div>
    );
};

export default React.memo(Search);
